import { useState } from 'react';

import { sortBy } from '../../lib/utils/sort-by';

export type SortDirection = 'asc' | 'desc';

export type OrderBy = {
  key: string;
  direction: SortDirection;
} | null;

export const useOrderBy = (defaultKey = 'createdAt', defaultDirection: SortDirection = 'desc') => {
  const [orderBy, setOrderBy] = useState<OrderBy>(null);

  /**
   * Cycles a column through ascending → descending → back to the default ordering.
   */
  const toggleOrder = (key: string) => {
    if (orderBy?.key !== key) {
      setOrderBy({ key, direction: 'asc' });
    } else if (orderBy.direction === 'asc') {
      setOrderBy({ key, direction: 'desc' });
    } else {
      setOrderBy(null);
    }
  };

  const sort = <T>(items: T[]): T[] =>
    sortBy(items, orderBy?.key ?? defaultKey, orderBy?.direction ?? defaultDirection);

  return { orderBy, toggleOrder, sort };
};
